module.exports = __webpack_public_path__ + "93dfbf9f54d22bda5a698e9bf58b4a62.svg";